module.exports = __webpack_public_path__ + "img/plus_file.1e3deed7.svg";